export default {
    methods: {
        differenceFromNowInDays (dateTimeString) {
            const date1 = new Date(dateTimeString)
            const date2 = new Date()

            const diffInTime = date2.getTime() - date1.getTime()

            return Math.round(diffInTime / (1000 * 3600 * 24))
        },
        differenceFromNow (dateTimeString, returnType = 'date') {
            const date = (new Date(dateTimeString))
            const month = date.getMonth() <= 9 ? `0${date.getMonth()}` : date.getMonth()
            const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()

            switch (this.differenceFromNowInDays(dateTimeString)) {
            case 0: return returnType === 'date' ? this.$t('اليوم') : date.toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit'})
            case 1: return this.$t('بالأمس')
            default: return `${date.getFullYear()}-${month}-${day}`
            }
        }
    }
}
